import { useApp } from 'contexts/app';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Button, Stack, Text } from 'shell/components';

const InstantStudentFeedback = ({ assignment }) => {
    const { studentAccountUsers, feedback: allFeedback } = useApp();
    const history = useHistory();
    const { t } = useTranslation('assignment');

    const feedback = allFeedback?.filter(({ owner_account_id }) => {
        return studentAccountUsers.some((student) => student.owner_account_id === owner_account_id);
    });

    const handleClick = () => {
        history.push(`/assignments/${assignment.id}/feedback`);
    };

    return (
        <Stack alignItems={'flex-start'} spacing={2}>
            <Text variant={'sh2'} weight={'semibold'}>
                {t('feedback-section.instant-student-feedback.title', 'Instant Student Feedback')}
            </Text>
            <Text color={'light'}>
                {assignment.is_draft
                    ? t(
                          'feedback-section.instant-student-feedback.description-draft',
                          'Please publish this assignment to get started with instant student feedback.'
                      )
                    : t(
                          'feedback-section.instant-student-feedback.description-published',
                          'You can review and edit feedback your students have generated for their assignment drafts here.'
                      )}
            </Text>
            <Button disabled={!feedback?.length} variant={'borderless'} onClick={handleClick}>
                {t('feedback-section.view-feedback', 'View Feedback')}
            </Button>
        </Stack>
    );
};

export default InstantStudentFeedback;
